import React from "react";
import Blog_header from "../components-blog/header";
import Blog_sidebar from "../components-blog/sidebar";
import Content_post from "../components-single-blog/content-post";
import Share_post from "../components-single-blog/share-post";
import Navigation_post from "../components-single-blog/navigation-post";
import Comment_post from "../components-single-blog/comment-post";

function Single_blog({ data }) {
  return (
    <div
      id="single-blog"
      // data-id={id}
    >
      <Blog_header />
      <div className="blog-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-12">
              <Content_post
                // id={post.id}
                title={data.title}
                image={data.photo}
                content={data.description}
              />
              <Share_post id={data.slug} title={data.title} image={data.photo} />
              <Navigation_post />
              <Comment_post id={data.slug} />
            </div>
            <div className="col-lg-4 col-12">
              <Blog_sidebar />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Single_blog;
